<template>
  <BaseModal
    ref="modal"
    header-title="Discover All Topics"
    content-class="max-w-6xl !bg-capino-light"
    skin-padding="p-2 md:p-8"
    @close="handleClose"
  >
    <div class="max-w-7xl w-full mx-auto flex flex-col">
      <TheSections
        :is-search="false"
        :is-filters="false"
        is-demo
        :is-stars="false"
        is-random-stars
        is-readonly
        :is-back-to-top-button="false"
      />

      <div class="p-4 pt-0">
        <BaseButton
          color="primary-gradient"
          @click="() => $refs.modal.handleClose()"
        >
          <span>Close</span>
        </BaseButton>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/Base/BaseModal.vue'
import BaseButton from '@/components/Base/BaseButton.vue'
import TheSections from '@/components/Hub/Sections/TheSections.vue'

export default {
  name: 'DemoAllSectionModal',

  components: { BaseModal, BaseButton, TheSections },

  methods: {
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>
